/**
 * myTeamApi.js
 * ------------
 * API client for My Team module.
 * Connects directly to FastAPI endpoint /self-service/team/ adhering to Rule 90.
 */
import api from '../../../../api/client';

export const DEPARTMENT_OPTIONS = [
  { value: 'All', label: 'All Departments' },
  { value: 'Engineering & DevOps', label: 'Engineering & DevOps' },
  { value: 'Product Development', label: 'Product Development' },
  { value: 'UI/UX & Design', label: 'UI/UX & Design' },
  { value: 'QA & Compliance', label: 'QA & Compliance' },
  { value: 'Operations & Facilities', label: 'Operations & Facilities' },
  { value: 'Human Resources', label: 'Human Resources' },
  { value: 'Finance & Accounts', label: 'Finance & Accounts' },
];

export const myTeamApi = {
  getList: async () => {
    try {
      const response = await api.get('/self-service/team/');
      return { data: response.data.data || [] };
    } catch (err) {
      console.warn('Failed to fetch team members from server:', err);
      return { data: [] };
    }
  },
};
